var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.toasts),function(toast,index){return _c('div',{key:index,staticClass:"toast toast--is-active",class:{
		'toast--success': toast.type === 'success', 
		'toast--error': toast.type === 'error',
		'toast--info': toast.type === 'info'
	}},[_c('p',[_vm._v(_vm._s(_vm._f("locale")(toast.title)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }